import _ from 'lodash'
import safeStorage from './SafeLocalStorage'

const localStorageKey = 'fiton:local:resource'
const localStorageVersionKey = 'fiton:local:resource:version'
const localStorageCategoryListKey = 'fiton:local:categoryList'
const localStorageLanguageSuffixKey = 'fiton:local:languageSuffix'

export function getResource() {
  let output = safeStorage.getItem(localStorageKey)
  try {
    output = JSON.parse(output)
  } catch (e) {
    output = []
  }
  return output
}

export function setResource(res = []) {
  try {
    safeStorage.setItem(localStorageKey, JSON.stringify(res))
  } catch (e) {
    if (e.name === 'QuotaExceededError') {
      console.warn('Storage limit reached')
    }
  }
}

export function getResourceVersion() {
  return safeStorage.getItem(localStorageVersionKey)
}
export function setResourceVersion(version) {
  return safeStorage.setItem(localStorageVersionKey, version)
}

export function setCategoryList(res = []) {
  return safeStorage.setItem(localStorageCategoryListKey, JSON.stringify(res))
}

export function getCategoryList() {
  let output = safeStorage.getItem(localStorageCategoryListKey)
  try {
    output = JSON.parse(output)
  } catch (e) {
    output = []
  }
  return output
}

export function setLanguageSuffix(res = []) {
  return safeStorage.setItem(localStorageLanguageSuffixKey, JSON.stringify(res))
}

export function getLanguageSuffix(suffix) {
  let output = safeStorage.getItem(localStorageLanguageSuffixKey)
  try {
    output = JSON.parse(output)
  } catch (e) {
    output = []
  }
  let language = _.find(output, { suffix: suffix })
  if (_.isEmpty(language)) {
    language = _.find(output, { suffix: 'EN' })
  }
  return language
}
